module.exports = __webpack_public_path__ + "img/bc_top.649bf3e3.png";